<div class="content-blk">
  <div class="container dv-stradmn-cmmsn">
    <h5 class="page-title">
      Commission List
    </h5>
    <div class="white-background">
      <small *ngIf="IsPayPalConfig ==false" class="blink_me text-danger">*Please configure Paypal to recieve commission in account setting.</small>
      <!-- <small *ngIf="IsPayPalConfig ==true" class="text-success">*Paypal is already configured, please check account setting to verify paypal detail.</small> -->
      <form class="example-form  pull-right" [formGroup]="searchCommission">
        <div class="srch-flt-rt">
          <mat-form-field floatLabel="never">
            <mat-select placeholder="Order Status" formControlName="status"
                        (selectionChange)="fn_searchCommission(searchCommission)">
              <mat-option value="">All</mat-option>
              <mat-option value="UNPAID">Unpaid</mat-option>
              <mat-option value="SUCCESS">Success</mat-option>
              <mat-option value="FAILED">Failed</mat-option>
              <mat-option value="ONHOLD">OnHold</mat-option>
              <mat-option value="PENDING">Pending</mat-option>
              <mat-option value="RETURNED">Returned</mat-option>
              <mat-option value="BLOCKED">Blocked</mat-option>
              <mat-option value="REFUNDED">Refunded</mat-option>
              <mat-option value="REVERSED">Reversed</mat-option>
              <mat-option value="UNCLAIMED">Unclaimed</mat-option>
            </mat-select>
          </mat-form-field>
          &nbsp;&nbsp;
          <mat-form-field floatLabel="never">
            <input matInput placeholder="Search" formControlName="search" ng-model-options="{debounce: 10000}"
                   (change)="fn_searchCommission(searchCommission)">
          </mat-form-field>
        </div>
      </form>
      <div class="search-results"
           infiniteScroll
           [infiniteScrollDistance]="6"
           [infiniteScrollThrottle]="100"
           [infiniteScrollDisabled]="isFullListDisplayed"
           (scrolled)="fn_GetCommissionList(true)">
        <div class="sp-admin-list-tbl pro-tble-outer cmsn-list cmsn-bx-ut">
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Store</th>
                  <th>Client Name</th>
                  <th>Order#</th>
                  <th>Order Date</th>
                  <th>Product Cost</th>
                  <th>Commission</th>
                  <!--<th>PayPal Config</th>-->
                  <th class="text-center">Status</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="isDisplay">
                  <td colspan="9" class="text-center">
                    No record(s) available
                  </td>
                </tr>
                <tr *ngFor="let item of commissionList; let i=index">
                  <td>{{i + 1}}</td>
                  <td style="text-transform:capitalize">{{item.StoreName}}</td>
                  <td style="text-transform:capitalize">
                    {{item.ClientName}}<br />
                    <small>{{item.ClientEmail}}</small>
                  </td>
                  <td>
                    <span title="View Order Status" class="mat-btn mat-track l-s-0-6" style="cursor: pointer;"
                          (click)="fn_RedirectToOrderDetail(item.OrderNo)">
                      {{item.OrderNo}}
                    </span>&nbsp;<span class="text-info">{{CustomizeType}}</span>
                    <strong>
                      <sup class="text-danger" *ngIf="item.IsSampleOrder">*Sample Order</sup>
                      <sup class="text-danger" *ngIf="item.IsShopifyOrder">*Shopify Order</sup>
                    </strong>
                  </td>
                  <td>{{item.OrderDate}}</td>
                  <td>{{item.OrderAmount | currency:'USD':'symbol':'1.2-2'}}</td>
                  <td>{{item.CommissionAmount | currency:'USD':'symbol':'1.2-2'}}</td>
                  <!--<td>
                    <span class="text-success" *ngIf="item.IsPayPalConfig">Active</span>
                    <span class="text-danger" *ngIf="!item.IsPayPalConfig">InActive</span>
                  </td>-->
                  <td class="text-center">
                    <label *ngIf="item.PayoutPaymentStatus==null" class="text-danger">
                      UnPaid
                    </label>
                    <label *ngIf="item.PayoutPaymentStatus!=null" class="text-info">
                      {{item.PayoutPaymentStatus}}
                    </label>
                  </td>

                </tr>
              </tbody>
            </table>
          </div>
          <app-lazy-loader></app-lazy-loader>
        </div>
      </div>
    </div>
  </div>
</div>
